<template>
    <transition name="trs-simple-fade">
        <div class="cookie-banner grid grid__custom-1" v-if="!hasUserAccepted">
            <div class="grid--container">
                <div class="cookie-banner--row grid--row">
                    <div class="cookie-banner--message-col grid--col">
                        <slot/>
                    </div>

                    <div class="grid--col cookie-banner--actions cookie-banner--actions-col ">
                        <slot name="actions">
                            <button class="cookie-banner--button btn btn__small btn__has-grid" @click="onConfirm">
                                {{ confirmLabel }}
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { readCookie, writeCookie } from 'util/dom/cookie';

    const path = '/';

    export default {
        props: {
            confirmLabel: {
                type: String,
                default: 'Ok',
            },

            cookieName: {
                type: String,
                default: 'cookies_accepted',
            },
        },

        data() {
            return {
                hasUserAccepted: Boolean(readCookie(this.cookieName)),
            };
        },

        methods: {
            /**
             * Called when confirming the cookie
             */
            onConfirm() {
                writeCookie({ key: this.cookieName, value: true, path });
                this.hasUserAccepted = true;
            },
        },
    };
</script>
